<template>
  <div>
    <v-img
      src="../assets/electrostimulation.jpg"
      alt="fizjoterapia"
      height="50vh"
    >
      <div
        class="display-1 font-weight-black text-center imageDiv shadow"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        Kontakt
      </div>
      <div
        class="display-2 font-weight-black text-center imageDiv shadow"
        v-else
      >
        Kontakt
      </div>
    </v-img>
    <v-row class="infor">
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true"
      >
        <a href="/">
          <img
            width="85"
            height="70"
            class="marginImg"
            src="../assets/olmed.png"
          />
        </a>
        <div class="display-1 font-weight-black grey--text text-center">
          Umów się na wizytę
        </div>
        <div class="textWhyPhone">
          <p>dr Aleksandra Skomudek</p>
          <!-- <p>
            <a
              href="https://www.moment.pl/olio?employee_id=88945#"
              target="__blank"
            >
              <v-icon size="28px">mdi-calendar</v-icon>
              Rezerwacja wizyt</a
            >
          </p> -->
          <p>
            Opole, ul. Oleska 3 (wejście od podwórka), gabinet nr 3
          </p>
          <p>
            <a href="mailto:olreh.opole@gmail.com">
              <v-icon size="28px">mdi-email</v-icon>
              olreh.opole@gmail.com</a
            >
          </p>
          <p>
            <a href="tel:+48 730 230 674"
              ><v-icon size="28px">mdi-phone</v-icon>+48 730 230 674</a
            >
          </p>
          <p>
            <a href="https://www.facebook.com/fizjo.aleksandraskomudek"
              ><v-icon size="28px">mdi-facebook</v-icon>Zobacz również na
              Facebook'u</a
            >
          </p>
          <p>
            <b
              >Fizjoterapia w gabinecie jak również z możliwością dojazdu do
              pacjenta</b
            >
          </p>
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <a href="/">
          <img
            width="85"
            height="70"
            class="marginImg"
            src="../assets/olmed.png"
          />
        </a>
        <div class="display-2 font-weight-black grey--text text-center">
          Umów się na wizytę
        </div>
        <div class="textWhy">
          <p>dr Aleksandra Skomudek</p>
          <!-- <p>
            <a
              href="https://www.moment.pl/olio?employee_id=88945#"
              target="__blank"
            >
              <v-icon size="28px">mdi-calendar</v-icon>
              Rezerwacja wizyt</a
            >
          </p> -->
          <p>
            Opole, ul. Oleska 3 (wejście od podwórka), gabinet nr 3
          </p>
          <p>
            <a href="mailto:olreh.opole@gmail.com">
              <v-icon size="28px">mdi-email</v-icon>
              olreh.opole@gmail.com</a
            >
          </p>
          <p>
            <a href="tel:+48 730 230 674"
              ><v-icon size="28px">mdi-phone</v-icon>+48 730 230 674</a
            >
          </p>
          <p>
            <a href="https://www.facebook.com/fizjo.aleksandraskomudek"
              ><v-icon size="28px">mdi-facebook</v-icon>Zobacz również na
              Facebook'u</a
            >
          </p>
          <p>
            <b
              >Fizjoterapia w gabinecie jak również z możliwością dojazdu do
              pacjenta</b
            >
          </p>
        </div>
      </v-col>
    </v-row>
    <v-img src="../assets/mapa.jpg" alt="dojazd" height="52vh"> </v-img>
  </div>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-application .grey--text {
  color: #414149 !important;
}
.imageDiv {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shadow {
  font-weight: 900;
  text-shadow: 3px 2px #000000;
  color: white;
  text-align: center;
}
.infor {
  padding: 15px;
}
.infText {
  margin: auto;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  text-align: justify;
  text-align-last: center;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
a:link,
a:visited {
  color: rgba(0, 0, 0, 0.87) !important;
  text-decoration-line: none;
}
a:hover {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600;
  transition: all 0.5s ease-out;
}
</style>
